<script setup>

import AccountsRow from '../components/AccountsRow.vue';
import { onBeforeMount, onMounted } from "vue";
import setTooltip from "../assets/js/tooltip";
import router from "../router";
import cookie from '../assets/js/cookies.js';
import validSession from "../assets/js/valid-session.js";
import bootstrap from "bootstrap/dist/js/bootstrap";
import { useStore } from "vuex";
import axios from "axios";
import { toast } from 'vue3-toastify';
import loadGif from "@/assets/img/loading.gif"
import { computed } from "vue";
import { useI18n } from 'vue-i18n';

const value_balance = {
    value: 0
};

const { t } = useI18n();

const money = {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false /* doesn't work with directive */
        }

const getIcons = async () => {

    axios.get('bank-icons?type=account')
    .then(res => {
        
        if(res.status == 200){

            store.state.icons = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

onBeforeMount(() => {

    validSession.isLogged();

    store.state.validation = {
        nameHasError: false,
        nameMessageError: '',
    };

    store.state.account = {
        icon: 'https://assets.agive.com.br/financas/bancos/banco-logo.png',
        name: '',
        not_sum: false,
        id: '',
        balance: ''
    };

    store.state.icons = [];
    store.state.accounts = [];
    store.state.loadingAccounts = true;
    store.state.editBalance = false;

    store.state.toArchive = {
        icon: '',
        name: '',
    };

    getIcons();

    store.state.loadingAccounts = true;
    getAccounts();
  
})

onMounted(() => {
    setTooltip();

    let session = cookie.get('user_agive_session');

    if(session == null){
        router.push({name: 'Login'});
    }

});

const clearFields = () => {
    store.state.account = {
        icon: 'https://assets.agive.com.br/imgs/bancos/banco-logo.png',
        name: '',
        not_sum: false,
        id: '',
        balance: 0
    };

    store.state.editBalance = false;

    store.state.toArchive = {
        icon: '',
        name: '',
    };
}

const getAccounts = async () => {

    axios.get('accounts')
    .then(res => {
        
        if(res.status == 200){

            store.state.accounts = res.data;
            store.state.loadingAccounts = false;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const submitAccount = async () => {

    let data = new FormData();

    store.state.validation.nameHasError = false;

    data.append('name', store.state.account.name);
    data.append('icon', store.state.account.icon);
    data.append('sum', store.state.account.not_sum == true ? 'No' : 'Yes');

    let url = '/accounts';
    let toast_message = t('message.accounts.account_created');

    if(store.state.account.id != ''){

        //console.log(value_balance);

        store.state.account.balance = value_balance.value.replace('R$ ', '');

        data.append('balance', store.state.account.balance);

        url = '/accounts/update/'+store.state.account.id;
        toast_message = t('message.accounts.account_updated');
    }

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'name'){
                    store.state.validation.nameHasError = true;
                    store.state.validation.nameMessageError = value[1];
                }

            })

        }
        else{

            store.state.validation = {
                nameHasError: false,
                nameMessageError: '',
            };

            closeModal('addAccount');

            clearFields();

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            getAccounts();

        }

    })
    .catch(err => {
        console.error(err); 
    })

}

const editAccount = (data) => {

    value_balance.value = formatMoney(data.balance);

    store.state.account = {
        icon: data.icon,
        name: data.name,
        not_sum:  data.sum == 'Yes' ? false : true,
        id: data.id,
        balance: data.balance
    };

}

const archiveAccount = async (account, archive) => {

    if(archive == 'Yes'){

        store.state.toArchive = {
            icon: account.icon,
            name: account.name,
        };

        openModal('confirmArchiveAccount');

        var confirmButton = document.getElementById('confirmArchiveAccountButton');
        confirmButton.addEventListener('click', async function () {
        // do something...
        
            let data = new FormData();

            data.append('archived', archive);

            let url = '/accounts/archive/'+account.id;
            let toast_message = t('message.accounts.account_archived');

            await axios.post(url, data)
            .then(res => {

                if(res.data.error){

                    console.log(res);

                }
                else{

                    toast(toast_message, {
                        autoClose: 1000,
                        theme: "auto",
                        type: "success",
                        transition: "slide"
                    });

                    closeModal('confirmArchiveAccount');
                    
                    getAccounts();

                }

            })
            .catch(err => {
                console.error(err); 
            })
            

        })

    }
    else{

        let data = new FormData();

        data.append('archived', archive);

        let url = '/accounts/archive/'+account.id;
        let toast_message = t('message.accounts.account_desarchived');

        await axios.post(url, data)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                closeModal('confirmArchiveAccount');
                
                getAccounts();

            }

        })
        .catch(err => {
            console.error(err); 
        })

    }    

}

const deleteAccount = async (account) => {

    store.state.toArchive = {
        icon: account.icon,
        name: account.name,
    };

    openModal('deleteAccount');

    var confirmButton = document.getElementById('confirmExclusionAccountButton');
    confirmButton.addEventListener('click', async function () {
    // do something...

        let url = '/accounts/delete/'+account.id;
        let toast_message = t('message.accounts.account_deleted');

        await axios.post(url)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                closeModal('deleteAccount');
                
                getAccounts();

            }

        })
        .catch(err => {
            console.error(err); 
        })
        

    })

}

const openModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.show();

}

const closeModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.hide();

}

function formatMoney(v) {
      let total = parseFloat(v);

      return total.toLocaleString(t('message.global.date_language'), {
        style: "currency",
        currency: "BRL",
      });
    }

</script>
<template>
    <div class="py-4 container-fluid overflow-auto max-height-vh-90">
        <div class="row">
            <div class="col-12">

                <div class="card accounts-premium-card border-0">
                    <div class="card-header accounts-premium-header border-0">
                        <div class="accounts-header-top">
                            <div class="accounts-title-wrap">
                                <span class="accounts-eyebrow">{{ t('message.global.bank_account', 2) }}</span>
                                <h3 class="accounts-title">Contas</h3>
                                <p class="accounts-subtitle mb-0">Gerencie suas contas de forma mais clara, rápida e organizada.</p>
                            </div>

                            <div class="accounts-header-actions">
                                <a 
                                    class="accounts-add-btn"
                                    type="button" 
                                    id="dropdownMenuButton1"
                                    @click="openModal('addAccount')"
                                >
                                    <i class="fal fa-plus-circle"></i>
                                    <span>{{ t('message.global.add') }}</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="card-body accounts-premium-body">
                        <div class="accounts-surface">
                            <div class="row">
                                <div class="col-12 text-center mt-4" v-if="store.state.loadingAccounts">
                                    <img :src="loadGif" alt="" width="60px">
                                </div>

                                <div class="accounts-empty-state" v-if="store.state.accounts.length == 0 && !store.state.loadingAccounts">
                                    <div class="accounts-empty-icon">
                                        <i class="fal fa-university"></i>
                                    </div>
                                    <div>
                                        <strong>Nenhuma conta cadastrada</strong>
                                        <p class="mb-0">{{ t('message.global.zero_accounts') }}</p>
                                    </div>
                                </div>

                                <div class="col-12 mt-2 mb-2 accounts-list-wrap" v-if="!store.state.loadingAccounts && store.state.accounts.length > 0">
                                    <AccountsRow
                                        v-for="(account, index) in store.state.accounts" :key="index"
                                        :bank="account.name"
                                        :id="account.id"
                                        :icon="account.icon"
                                        :edit="account"
                                        :darkmode="darkMode"
                                        @edit="editAccount"
                                        @archive="archiveAccount"
                                        @delete="deleteAccount"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="addAccount" tabindex="-1" aria-labelledby="addAccount" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable account-modern-modal-dialog">
            <div class="modal-content account-modern-modal-content">
                <div class="modal-body account-modern-modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="account-modern-modal-header">
                        <div>
                            <div class="account-modern-modal-eyebrow">Contas</div>
                            <h4 class="account-modern-modal-title">
                                {{ store.state.account.id == '' ? t('message.accounts.new_account') : t('message.accounts.update_account') }}
                            </h4>
                            <p class="account-modern-modal-subtitle">Cadastre a conta, escolha o banco e personalize as configurações.</p>
                        </div>

                        <button
                            type="button"
                            class="account-modern-close"
                            data-bs-dismiss="modal"
                            @click="clearFields()"
                        >
                            <i class="fal fa-times"></i>
                        </button>
                    </div>

                    <div class="account-modern-preview-card">
                        <div class="account-modern-preview-icon">
                            <img :src="store.state.account.icon" alt="" class="img-fluid rounded-5">
                        </div>

                        <div class="account-modern-preview-text">
                            <span class="account-modern-preview-label">Pré-visualização</span>
                            <strong>{{ store.state.account.name || 'Nome da conta' }}</strong>
                            <small>{{ store.state.account.id != '' ? formatMoney(store.state.account.balance) : 'Saldo inicial opcional' }}</small>
                        </div>
                    </div>

                    <div class="account-modern-form-card">
                        <div class="row g-3">
                            <div class="col-12">
                                <label for="accountName" class="account-modern-label">{{ t('message.accounts.account_name') }}</label>
                                <input 
                                    type="text" 
                                    class="form-control form-control-lg account-modern-input" 
                                    id="accountName"
                                    name="accountName"
                                    :placeholder="t('message.accounts.account_name')"
                                    v-model="store.state.account.name"
                                    v-bind:class="{
                                        'is-invalid': store.state.validation.nameHasError,
                                        'darkmode': darkMode,
                                    }"
                                >
                                <div id="categoryNameFeedback" class="invalid-feedback">
                                    {{ store.state.validation.nameMessageError }}
                                </div>
                            </div>

                            <div v-if="store.state.account.id > 0 && !store.state.editBalance" class="col-12">
                                <div class="account-balance-display">
                                    <div>
                                        <span>Saldo atual</span>
                                        <strong>{{formatMoney(store.state.account.balance)}}</strong>
                                    </div>

                                    <button
                                        type="button"
                                        class="account-balance-edit-btn"
                                        @click="store.state.editBalance = true"
                                        v-tooltip="{
                                            content:t('message.global.edit') + ' ' + t('message.global.balance'),
                                            distance: 15
                                        }"
                                    >
                                        <i
                                            class="fal fa-pencil"
                                            v-bind:class="{
                                                'text-black-50': !darkMode,
                                                'text-white-50': darkMode,
                                            }"
                                        ></i>
                                    </button>
                                </div>
                            </div>

                            <div v-if="store.state.account.id > 0 && store.state.editBalance" class="col-12">
                                <label for="accountBalance" class="account-modern-label">{{ t('message.global.balance') }}</label>
                                <input 
                                    type="tel" 
                                    class="form-control form-control-lg account-modern-input" 
                                    id="accountBalance"
                                    name="accountBalance"
                                    :placeholder="t('message.accounts.account_balance')"
                                    v-model.lazy="value_balance.value" 
                                    v-money="money"
                                    v-bind:class="{
                                        'darkmode': darkMode,
                                    }"
                                >
                                <p class="account-modern-help mb-0">
                                    {{ t('message.accounts.negative') }}
                                </p>
                            </div>

                            <div class="col-12">
                                <div class="account-modern-switch-row">
                                    <div class="account-modern-switch-copy">
                                        <strong>{{ t('message.accounts.not_sum') }}</strong>
                                        <small v-tooltip="{
                                            content: t('message.accounts.not_sum_tooltip'), 
                                            html: true,
                                            distance: 15
                                        }">Essa conta não será considerada no saldo consolidado.</small>
                                    </div>

                                    <label class="account-modern-switch">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="store.state.account.not_sum">
                                        <span></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="account-modern-section-card">
                        <div class="account-modern-section-head">
                            <h5>{{ t('message.global.choose_icon') }}</h5>
                            <span>{{ store.state.account.name || 'Banco' }}</span>
                        </div>

                        <div class="account-modern-icons-scroll">
                            <div class="account-modern-icon-grid">
                                <button
                                    v-for="(icon, index) in store.state.icons" :key="index"
                                    type="button"
                                    @click="store.state.account.icon = icon.path"
                                    class="account-modern-icon-item"
                                    :class="{ 'is-active': store.state.account.icon == icon.path }"
                                    :title="icon.name"
                                >
                                    <img :src="icon.path" :alt="icon.name" class="rounded-5">
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="account-modern-footer">
                        <button
                            @click="submitAccount()"
                            class="btn account-modern-submit"
                        >
                            {{ store.state.account.id == '' ? t('message.accounts.add_account') : t('message.accounts.update_account') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="confirmArchiveAccount" tabindex="-1" aria-labelledby="confirmArchiveAccount" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-11 mx-auto mt-4 mb-4">
                            <h5 class="mb-4">{{ t('message.accounts.archive_title') }}</h5>

                            <div class="col-12 text-center mt-3 mb-3">
                                <img :src="store.state.toArchive.icon" alt="" width="100" class="rounded">
                                <br>
                                <h4>{{store.state.toArchive.name}}</h4>
                            </div>

                            <div class="col-12 col-lg-10 mx-auto text-start mt-3 mb-3" v-html="t('message.accounts.archive_disclaim')">
                                
                            </div>

                        </div>
                        <div class="col-12 text-center">
                            <button
                                id="confirmArchiveAccountButton" 
                                class="btn btn-success"
                            >
                                {{ t('message.accounts.archive_button') }}
                            </button>

                            <a @click="closeModal('confirmArchiveAccount')" class="btn btn-link">{{ t('message.global.cancel') }}</a>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="deleteAccount" tabindex="-1" aria-labelledby="deleteCategoryModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="col-11 mx-auto mt-4 mb-4">
                        <h5 class="mb-4">{{ t('message.accounts.delete_title') }}</h5>

                        <div class="col-12 text-center mt-3 mb-3">
                            <img :src="store.state.toArchive.icon" alt="" width="60" class="rounded">
                            <br>
                            <h4>{{store.state.toArchive.name}}</h4>
                        </div>

                        <div class="col-12 col-lg-10 mx-auto text-start mt-3 mb-3" v-html="t('message.accounts.delete_disclaim')">
                            
                        </div>

                    </div>
                    <div class="col-12 text-center">
                        <button
                            id="confirmExclusionAccountButton" 
                            class="btn btn-danger"
                        >
                            {{ t('message.accounts.delete_button') }}
                        </button>

                        <a @click="closeModal('deleteAccount')" class="btn btn-link">{{ t('message.global.cancel') }}</a>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

</template>

<style>
    .accounts-premium-card{
        overflow: hidden;
        border-radius: 24px !important;
        background: #f6f3eb;
        box-shadow: 0 12px 40px rgba(24, 39, 75, 0.08);
    }

    .accounts-premium-header{
        padding: 1.8rem 1.5rem 1.5rem;
        background: linear-gradient(135deg, #1f4876 0%, #224a78 55%, #1f436d 100%);
    }

    .accounts-header-top{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
    }

    .accounts-title-wrap{
        min-width: 0;
    }

    .accounts-eyebrow{
        display: inline-block;
        margin-bottom: 10px;
        font-size: 0.92rem;
        color: rgba(255,255,255,0.78);
    }

    .accounts-title{
        margin: 0;
        font-size: 2rem;
        line-height: 1.1;
        font-weight: 800;
        color: #ffffff;
    }

    .accounts-subtitle{
        margin-top: 10px;
        color: rgba(255,255,255,0.66);
        font-size: 1rem;
    }

    .accounts-header-actions{
        flex-shrink: 0;
    }

    .accounts-add-btn{
        height: 52px;
        padding: 0 18px;
        border-radius: 16px;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        color: #fff !important;
        background: rgba(255,255,255,0.08);
        border: 1px solid rgba(255,255,255,0.14);
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.08);
        transition: all .2s ease;
        cursor: pointer;
        text-decoration: none;
        backdrop-filter: blur(6px);
    }

    .accounts-add-btn:hover{
        transform: translateY(-1px);
        background: rgba(255,255,255,0.14);
        color: #fff !important;
    }

    .accounts-premium-body{
        padding: 1.4rem !important;
        background: #f7f4ee;
    }

    .accounts-surface{
        padding: 1rem 1rem .75rem;
        border-radius: 24px;
        background: rgba(255,255,255,0.62);
        border: 1px solid rgba(213, 205, 193, 0.5);
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.45);
    }

    .accounts-list-wrap{
        display: flex;
        flex-direction: column;
        gap: .25rem;
    }

    .accounts-empty-state{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: .85rem;
        min-height: 260px;
        border: 1px dashed rgba(17, 24, 39, 0.12);
        border-radius: 20px;
        background: linear-gradient(180deg, rgba(248, 247, 243, 0.7), #fff);
        color: #6f7b8c;
        text-align: center;
        padding: 1.5rem;
        margin: .5rem;
    }

    .accounts-empty-state strong{
        display: block;
        color: #213E60;
        font-size: 1rem;
        margin-bottom: .2rem;
    }

    .accounts-empty-icon{
        width: 66px;
        height: 66px;
        border-radius: 18px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 1.45rem;
        color: #d89239;
        background: rgba(216, 146, 57, 0.12);
    }

    .account-modern-modal-dialog {
        max-width: 760px;
    }

    .account-modern-modal-content {
        border: none;
        border-radius: 26px;
        overflow: hidden;
        background: #f8f7f3;
        box-shadow: 0 24px 70px rgba(15, 23, 42, 0.18);
    }

    .account-modern-modal-body {
        padding: 1.2rem !important;
        max-height: calc(100vh - 2rem);
        overflow-y: auto;
        overflow-x: hidden;
        background: linear-gradient(180deg, #fcfcfa 0%, #f7f5ef 100%);
        -webkit-overflow-scrolling: touch;
    }

    .account-modern-modal-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem;
        margin-bottom: 1rem;
    }

    .account-modern-modal-eyebrow {
        color: #7183a1;
        font-size: 0.88rem;
        font-weight: 700;
        margin-bottom: 0.25rem;
    }

    .account-modern-modal-title {
        margin: 0;
        color: #213E60;
        font-size: 1.7rem;
        font-weight: 800;
        line-height: 1.1;
    }

    .account-modern-modal-subtitle {
        margin: 0.45rem 0 0;
        color: #6b7c93;
        font-size: 0.96rem;
    }

    .account-modern-close {
        width: 42px;
        height: 42px;
        min-width: 42px;
        border: 1px solid #d7e0ea;
        border-radius: 14px;
        background: #ffffff;
        color: #607392;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all .2s ease;
    }

    .account-modern-close:hover {
        transform: translateY(-1px);
        background: #eef4fb;
        border-color: #a8bfd9;
    }

    .account-modern-preview-card,
    .account-modern-form-card,
    .account-modern-section-card {
        background: rgba(255,255,255,0.88);
        border: 1px solid #dbe5f0;
        border-radius: 22px;
        box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
    }

    .account-modern-preview-card {
        display: flex;
        align-items: center;
        gap: 0.95rem;
        padding: 1rem 1.05rem;
        margin-bottom: 1rem;
    }

    .account-modern-preview-icon {
        width: 72px;
        height: 72px;
        min-width: 72px;
        border-radius: 20px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 22px rgba(15, 23, 42, 0.10);
        padding: 10px;
    }

    .account-modern-preview-icon img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .account-modern-preview-text {
        display: flex;
        flex-direction: column;
        gap: 0.18rem;
        min-width: 0;
    }

    .account-modern-preview-label {
        color: #7183a1;
        font-size: 0.86rem;
        font-weight: 700;
    }

    .account-modern-preview-text strong {
        color: #213E60;
        font-size: 1.02rem;
        font-weight: 800;
        word-break: break-word;
    }

    .account-modern-preview-text small {
        color: #6b7c93;
        font-size: 0.86rem;
    }

    .account-modern-form-card {
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .account-modern-label {
        display: block;
        margin-bottom: 0.45rem;
        color: #344766;
        font-weight: 700;
        font-size: 0.95rem;
    }

    .account-modern-input {
        min-height: 54px !important;
        border-radius: 15px !important;
        border: 1px solid #d7e0ea !important;
        background: #ffffff !important;
        box-shadow: none !important;
        color: #344766;
    }

    .account-modern-input:focus {
        border-color: #8aa8ca !important;
        box-shadow: 0 0 0 4px rgba(138, 168, 202, 0.14) !important;
    }

    .account-modern-input::placeholder {
        color: #9aa8bb;
    }

    .account-balance-display {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding: 0.95rem 1rem;
        border: 1px solid #dbe5f0;
        border-radius: 18px;
        background: #f8fafc;
    }

    .account-balance-display span {
        display: block;
        color: #6b7c93;
        font-size: 0.82rem;
        margin-bottom: 0.2rem;
    }

    .account-balance-display strong {
        color: #213E60;
        font-size: 1.18rem;
        font-weight: 800;
    }

    .account-balance-edit-btn {
        width: 38px;
        height: 38px;
        border: 1px solid #d7e0ea;
        border-radius: 12px;
        background: #ffffff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all .2s ease;
    }

    .account-balance-edit-btn:hover {
        transform: translateY(-1px);
        background: #eef4fb;
        border-color: #a8bfd9;
    }

    .account-modern-help {
        color: #6b7c93;
        font-size: 0.84rem;
        margin-top: 0.45rem;
    }

    .account-modern-switch-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding: 0.95rem 1rem;
        border: 1px solid #dbe5f0;
        border-radius: 18px;
        background: #f8fafc;
    }

    .account-modern-switch-copy strong {
        display: block;
        color: #344766;
        font-size: 0.98rem;
    }

    .account-modern-switch-copy small {
        display: block;
        margin-top: 0.15rem;
        color: #6b7c93;
        font-size: 0.84rem;
    }

    .account-modern-switch {
        position: relative;
        display: inline-flex;
        width: 52px;
        min-width: 52px;
        height: 30px;
    }

    .account-modern-switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .account-modern-switch span {
        position: absolute;
        inset: 0;
        border-radius: 999px;
        background: #d7e0ea;
        cursor: pointer;
        transition: .2s ease;
    }

    .account-modern-switch span::before {
        content: "";
        position: absolute;
        width: 22px;
        height: 22px;
        top: 4px;
        left: 4px;
        border-radius: 50%;
        background: #ffffff;
        box-shadow: 0 2px 8px rgba(15, 23, 42, 0.14);
        transition: .2s ease;
    }

    .account-modern-switch input:checked + span {
        background: #d89239;
    }

    .account-modern-switch input:checked + span::before {
        transform: translateX(22px);
    }

    .account-modern-section-card {
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .account-modern-section-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.75rem;
        margin-bottom: 0.9rem;
    }

    .account-modern-section-head h5 {
        margin: 0;
        color: #344766;
        font-size: 1rem;
        font-weight: 800;
    }

    .account-modern-section-head span {
        color: #6b7c93;
        font-size: 0.8rem;
        background: #f3f7fb;
        padding: 0.36rem 0.68rem;
        border-radius: 999px;
    }

    .account-modern-icons-scroll {
        max-height: 260px;
        overflow-y: auto;
        padding-right: 0.2rem;
    }

    .account-modern-icon-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(64px, 1fr));
        gap: 0.7rem;
    }

    .account-modern-icon-item {
        height: 60px;
        border-radius: 16px;
        border: 1px solid #d7e0ea;
        background: #f8fafc;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        transition: all .2s ease;
    }

    .account-modern-icon-item:hover {
        background: #eef4fb;
        border-color: #9fbad8;
        transform: translateY(-1px);
    }

    .account-modern-icon-item.is-active {
        background: #ffffff;
        border-color: #213E60;
        box-shadow: 0 0 0 4px rgba(33, 62, 96, 0.12);
    }

    .account-modern-icon-item img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .account-modern-footer {
        position: sticky;
        bottom: 0;
        z-index: 3;
        padding-top: 0.1rem;
    }

    .account-modern-submit {
        width: 100%;
        min-height: 52px;
        border: none !important;
        border-radius: 15px !important;
        background: linear-gradient(135deg, #d89239 0%, #c97d24 100%) !important;
        color: #ffffff !important;
        font-weight: 800 !important;
        box-shadow: 0 18px 34px rgba(201, 125, 36, 0.24);
    }

    .account-modern-submit:hover,
    .account-modern-submit:focus {
        transform: translateY(-1px);
        color: #ffffff !important;
        background: linear-gradient(135deg, #e09a40 0%, #cf8024 100%) !important;
    }

    .account-create-icon-div{
        height: 50px;
    }

    .account-create-icon{
        min-height: 100%;
    }

    .icon-picker{
        margin: 2px 4px 2px 0;
        width: 60px !important;
        height: 60px !important;
        cursor: pointer;
    }

    .icon-picker img {
        width: 100%;
        border-radius: 0.25rem
    }

    .icon-create{
        font-size: 30px;
    }

    .icon-list{
        height: 150px;
        overflow-x:auto;
    }

    .cursor-pointer{
        cursor: pointer;
    }

    @media (max-width: 991.98px) {
        .accounts-premium-header{
            padding: 1.3rem 1rem 1.2rem;
        }

        .accounts-header-top{
            flex-direction: column;
            align-items: stretch;
        }

        .accounts-title{
            font-size: 1.65rem;
        }

        .accounts-add-btn{
            width: 100%;
            justify-content: center;
        }

        .accounts-premium-body{
            padding: 1rem !important;
        }
    }

    @media (max-width: 575.98px) {
        .accounts-premium-card{
            border-radius: 20px !important;
        }

        .accounts-title{
            font-size: 1.35rem;
        }

        .accounts-subtitle{
            font-size: .9rem;
        }

        .accounts-surface{
            border-radius: 18px;
            padding: .75rem .5rem;
        }

        .accounts-empty-state{
            min-height: 190px;
            border-radius: 16px;
            padding: 1.25rem;
        }

        .account-modern-modal-dialog {
            margin: 0.5rem;
        }

        .account-modern-modal-body {
            padding: 0.9rem !important;
            max-height: calc(100vh - 1rem);
        }

        .account-modern-modal-title {
            font-size: 1.3rem;
        }

        .account-modern-preview-card {
            padding: 0.85rem;
        }

        .account-modern-preview-icon {
            width: 58px;
            height: 58px;
            min-width: 58px;
            border-radius: 16px;
        }

        .account-modern-switch-row,
        .account-modern-section-head,
        .account-balance-display {
            align-items: flex-start;
            flex-direction: column;
        }

        .account-modern-icon-grid {
            grid-template-columns: repeat(auto-fill, minmax(56px, 1fr));
            gap: 0.55rem;
        }

        .accounts-premium-card{
          margin-bottom: 60px;
        }
    }
</style>